import React from 'react';
import {GestureResponderEvent, Pressable} from 'react-native';

import {Icon} from '../../../components/Icon';

const TogglePasswordVisibleIconButton = ({
  onPress,
  isPasswordVisible,
}: {
  onPress: (event: GestureResponderEvent) => void;
  isPasswordVisible: boolean;
}) => (
  <Pressable onPress={onPress}>
    <Icon
      name={isPasswordVisible ? 'eye' : 'eye-slash'}
      iconStyle="regular"
      size={20}
      color="lightgrey"
    />
  </Pressable>
);

export default TogglePasswordVisibleIconButton;
